export const tableColumns = [
    { label: 'Фамилия, имя, отчество пациента', value: 'fullName' },
    { label: 'Дата рождения пациента', value: 'birthDate' },
    { label: 'Возраст пациента', value: 'age' },
    { label: 'Пол пациента', value: 'gender' },
    { label: 'Социальный статус пациента', value: 'socialStatus' },
    { label: 'Группа инвалидности пациента', value: 'disabilityGroup' },
    { label: 'Набор социальных услуг', value: 'socialServices' },
    { label: 'Прикрепление к медицинской организации', value: 'mobind' },
    { label: 'Номер участка', value: 'areanumber' },
    { label: 'Адрес места жительства пациента', value: 'address' },
    { label: 'Наличие стабильного клинического эффекта', value: 'stableclinicaleffect' },
    { label: 'Дата ДН по БСК за последний год', value: 'lastyearbskfollowupdate' },
    { label: 'ПМО или ДОГВН за последний год', value: 'lastyearpmoordgvn' },
    { label: 'Наличие диагноза I48.0-I48.9', value: 'hasi48' },
    { label: 'Д учет по диагнозу I48.0-I48.9', value: 'hasdispensaryi48' },
    { label: 'Дата запланированного посещения с целью ДН (следующей явки) по диагнозу I48.0-I48.9', value: 'i48NextPlannedVisitDate' },
    { label: 'Фактический уровень ЧСС', value: 'actualheartrate' },
    { label: 'Количество баллов по шкале CHA2DS2-VASc', value: 'cha2ds2vascscore' },
    { label: 'Антикоагулянтная терапия', value: 'anticoagulanttherapy' },
    { label: 'Наличие диагноза I50.0-I50.9', value: 'hasi50' },
    { label: 'Д учет по диагнозу I50.0-I50.9', value: 'hasdispensaryi50' },
    { label: 'Наличие диагноза I10-I13', value: 'hasi10_i13' },
    { label: 'Д учет по диагнозу I10-I13', value: 'hasdispensaryi10_i13' },
    { label: 'Целевой уровень диастолического АД', value: 'targetDiastolicPressure' },
    { label: 'Фактический уровень диастолического АД', value: 'actualDiastolicPressure' },
    { label: 'Целевой уровень АД достигнут', value: 'targetbloodpressureachieved' },
    { label: 'Наличие диагноза I65.2', value: 'hasi65_2' },
    { label: 'Д учет по диагнозу I65.2', value: 'hasdispensaryi65_2' },
    { label: 'Наличие диагноза I20, I25', value: 'hasi20_i25' },
    { label: 'Д учет по диагнозу I20, I25', value: 'hasdispensaryi20_i25' },
    { label: 'Наличие диагноза I26.0, I26.9', value: 'hasi26' },
    { label: 'Д учет по диагнозу I26.0, I26.9', value: 'hasdispensaryi26' },
    { label: 'Наличие диагноза Е78', value: 'hase78' },
    { label: 'Д учет по диагнозу E78', value: 'hasdispensarye78' },
    { label: 'Дата запланированного посещения с целью ДН (следующей явки) по диагнозу E78', value: 'e78NextPlannedVisitDate' },
    { label: 'Фактический уровень ЛПНП', value: 'actualldl' },
    { label: 'Дата проведения ЧКВ', value: 'pcidate' },
    { label: 'Дата проведения АКШ и МКШ', value: 'cabgdate' },
    { label: 'Дата проведения КАГ', value: 'cagdate' },
    { label: 'Дата проведения дуплексного сканирования', value: 'duplexscandate' },
    { label: 'Консультации нейрохирурга', value: 'neurosurgeonconsultation' },
    { label: 'Операции по поводу атеросклероза', value: 'atherosclerosisoperations' },
    { label: 'Наличие в анамнезе I21,I22', value: 'hashistoryi21_i22' },
    { label: 'Д учет по диагнозу I21,I22', value: 'hasdispensaryi21_i22' },
    { label: 'Дата последней выписки с I21/I22', value: 'lastepicrisisi21_i22' },
    { label: 'Наличие в анамнезе I60.0-I64.9', value: 'hashistoryi60_i64' },
    { label: 'Д учет по диагнозу I60.0-I64.9', value: 'hasdispensaryi60_i64' },
    { label: 'Дата последней выписки с I60.0-I64.9', value: 'lastepicrisisi60_i64' },
    { label: 'Дата последней выписки с I48.0-I48.9', value: 'lastepicrisisi48' },
    { label: 'Дата последней выписки с I10-I13', value: 'lastepicrisisi10_i13' },
    { label: 'Дата последней выписки с I65.2', value: 'lastepicrisisi65_2' },
    { label: 'Дата последней выписки с I20,I25', value: 'lastepicrisisi20_i25' },
    { label: 'Дата последней выписки с I26.0,I26.9', value: 'lastepicrisisi26' },
    { label: 'Вызовы СМП с диагнозом I00-I99', value: 'emergencycallsi00_i99' },
    { label: 'Наличие диагноза Е10-Е11', value: 'hase10_e11' },
    { label: 'Д учет по диагнозу Е10-Е11', value: 'hasdispensarye10_e11' },
    { label: 'Дата запланированного посещения с целью ДН (следующей явки) по диагнозу E10-E11', value: 'e10E11NextPlannedVisitDate' },
    { label: 'Фактический уровень НвА1с', value: 'actualHbA1c' },
    { label: 'Наличие диагноза J44.0-J44.9', value: 'hasj44' },
    { label: 'Д учет по диагнозу J44.0-J44.9', value: 'hasdispensaryj44' },
    { label: 'Наличие диагноза N18.1-N18.9', value: 'hasn18' },
    { label: 'Д учет по диагнозу N18.1-N18.9', value: 'hasdispensaryn18' },
    { label: 'Дата исключения из регистра', value: 'registryexclusiondate' },
    { label: 'Дата запланированного посещения с целью ДН (следующей явки) по диагнозу I50.0-I50.9', value: 'i50NextPlannedVisitDate' },
    { label: 'Дата запланированного посещения с целью ДН (следующей явки) по диагнозу I10.0-I13', value: 'i10I13NextPlannedVisitDate' },
    { label: 'Целевой уровень систолического АД', value: 'targetSystolicPressure' },
    { label: 'Фактический уровень систолического АД', value: 'actualSystolicPressure' },
    { label: 'Дата запланированного посещения с целью ДН (следующей явки) по диагнозу I65.2', value: 'i652NextPlannedVisitDate' },
    { label: 'Дата запланированного посещения с целью ДН (следующей явки) по диагнозу I20, I25', value: 'i20I25NextPlannedVisitDate' },
    { label: 'Дата запланированного посещения с целью ДН (следующей явки) по диагнозу I26.0, I26.9', value: 'i26NextPlannedVisitDate' },
    { label: 'Дата запланированного посещения с целью ДН (следующей явки) по диагнозу J44.0-J44.9', value: 'j44NextPlannedVisitDate' },
    { label: 'Дата запланированного посещения с целью ДН (следующей явки) по диагнозу N18.1-N18.9', value: 'n18NextPlannedVisitDate' },
];
